import React from "react";
import {
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  ORG_ID,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SW_HBN_CLIENT_PARTNER_PRI,
  USERMANAGEMENT,
} from "../../../../constant/constant";
import Card from "../../../../library/custom/cardList/card";
import { Grid } from "@mui/material";
import {
  checkPrivileges,
  hasAllPrivileges,
  showRighSideMenu,
} from "../../../../utils/rolesHelper";

const UserManagementList = ({ onClick }) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isProcoreClient = userInfo?.isProcoreConnected;
  const ProcoreClientId = localStorage.getItem("IsProcoreConnected");
  const isClientSwitch = parseInt(ORG_ID()) !== parseInt(LOGIN_ORG_ID());
  let ShowCard = false;
  if (isClientSwitch) {
    if (ProcoreClientId === "true") {
      ShowCard = true;
    }
  } else {
    if (isProcoreClient) {
      ShowCard = true;
    }
  }
  const bouncedEmail =
    checkPrivileges([12]) ||
    hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI) ||
    hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI);

  const showMenu = showRighSideMenu();
  const groupAccessSW =
    showMenu?.isSW &&
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
    checkPrivileges([12, 55, 56]);
  const groupAccessSafety = showMenu?.isSafety && checkPrivileges([12, 55, 56]);

  return (
    <>
      <Grid container className="CardListContaner">
        {checkPrivileges([12, 64, 65, 66]) && (
          <>
            <Card
              iconShow={false}
              onClick={onClick}
              imgShow={true}
              cardDetail={USERMANAGEMENT[0]}
            />

            <Card
              iconShow={false}
              onClick={onClick}
              imgShow={true}
              cardDetail={USERMANAGEMENT[3]}
            />

            <Card
              iconShow={false}
              onClick={onClick}
              imgShow={true}
              cardDetail={USERMANAGEMENT[4]}
            />
          </>
        )}
        {(groupAccessSW || groupAccessSafety) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={USERMANAGEMENT[1]}
          />
        )}
        {checkPrivileges([12, 14, 76, 77]) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={USERMANAGEMENT[2]}
          />
        )}

        {checkPrivileges([12, 148]) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={USERMANAGEMENT[5]}
          />
        )}
        {ShowCard && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={USERMANAGEMENT[6]}
          />
        )}
        {bouncedEmail && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={USERMANAGEMENT[7]}
          />
        )}
      </Grid>
    </>
  );
};

export default UserManagementList;
